import React, { useState } from 'react';
import {
  BarChart3,
  UserCheck,
  Percent,
  Calendar,
  Settings,
  FileText,
  Code,
  Monitor,
  ChevronDown,
  ChevronRight,
  Folder,
  Gift,
  Bookmark,
  ShoppingCart,
  TrendingUp,
  BookOpen,
  Tag,
  CreditCard,
} from 'lucide-react';

const SuperAdminSidebar = ({ activeTab, setActiveTab, isOpen, setIsOpen }) => {
  const [expandedMenus, setExpandedMenus] = useState({});

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'provider-requests', label: 'Provider Requests', icon: UserCheck },
    { id: 'coupons', label: 'Coupon Management', icon: Gift },
    { id: 'course-categories', label: 'Course Categories', icon: Folder },
    { id: 'commission', label: 'Commission', icon: Percent },
    { id: 'events', label: 'Event Management', icon: Calendar },
    {
      id: 'support-tickets',
      label: 'Tickets',
      icon: Bookmark,
      hasDropdown: true,
      children: [
        { id: 'tickets', label: 'Ticket List', icon: Bookmark },
        { id: 'ticket-categories', label: 'Categories', icon: Tag },
      ],
    },
    { id: 'course-orders', label: 'Course Orders', icon: BookOpen },
    { id: 'earnings', label: 'Earnings', icon: TrendingUp },
    { id: 'withdrawals', label: 'Withdrawal Requests', icon: CreditCard },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      hasDropdown: true,
      children: [
        { id: 'basic-info', label: 'Basic Info', icon: Settings },
        { id: 'site', label: 'Site', icon: Monitor },
        { id: 'policies', label: 'Policies', icon: FileText },
        { id: 'api', label: 'API', icon: Code },
      ],
    },
  ];

  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => ({ ...prev, [menuId]: !prev[menuId] }));
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div
        className={`
        fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 lg:static lg:shadow-none
      `}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h1 className="text-xl font-bold text-gray-900">Super Admin</h1>
            <button
              onClick={() => setIsOpen(false)}
              className="lg:hidden p-2 rounded-md hover:bg-gray-100"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isExpanded = expandedMenus[item.id];
              const isActive =
                activeTab === item.id ||
                (item.children && item.children.some((c) => activeTab === c.id));

              if (item.hasDropdown) {
                return (
                  <div key={item.id} className="space-y-1">
                    <button
                      onClick={() => toggleMenu(item.id)}
                      className={`w-full flex items-center justify-between px-4 py-3 text-left rounded-lg transition-colors ${isActive ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-700' : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                      <div className="flex items-center">
                        <Icon className="w-5 h-5 mr-3" />
                        <span className="font-medium">{item.label}</span>
                      </div>
                      {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                    </button>
                    {isExpanded &&
                      item.children.map((child) => {
                        const ChildIcon = child.icon;
                        return (
                          <button
                            key={child.id}
                            onClick={() => {
                              setActiveTab(child.id);
                              setIsOpen(false);
                            }}
                            className={`w-full flex items-center px-4 py-2 pl-10 text-left rounded-lg text-sm ${activeTab === child.id
                              ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-700'
                              : 'text-gray-600 hover:bg-gray-100'
                              }`}
                          >
                            <ChildIcon className="w-4 h-4 mr-3" />
                            {child.label}
                          </button>
                        );
                      })}
                  </div>
                );
              }
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setActiveTab(item.id);
                    setIsOpen(false);
                  }}
                  className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors ${activeTab === item.id
                    ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-700'
                    : 'text-gray-700 hover:bg-gray-100'
                    }`}
                >
                  <Icon className="w-5 h-5 mr-3" />
                  <span className="font-medium">{item.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default SuperAdminSidebar;
